<template>
    <v-dialog-old ref="dialog" id="networkImportResult">
        <form>
            <fieldset style="max-width: 1000px">
                <legend>Результаты импорта </legend>
                <div>
                    Включено услуг: {{ result.total }}<br/>
                    С ценой: {{ result.total_with_price }}
                </div>
            </fieldset>
            <fieldset style="max-width: 1000px" v-if="errorsBag.length > 0">
                <legend>Возможные ошибки</legend>

                <table class="table">
                    <thead>
                    <tr align="center">
                        <td style="width: 89px" >Строка №</td>
                        <td style="width: 80px" >Id</td>
                        <td>Название</td>
                        <td style="width: 105px" >Подключена</td>
                        <td>Ошибка</td>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="error in errorsBag">
                        <td align="center">{{ error.line }}</td>
                        <td align="center">{{ error.id }}</td>
                        <td>{{ error.name }}</td>
                        <td align="center">{{ error.isActive ? 'Да': 'Нет' }} </td>
                        <td>{{ error.message }}</td>
                    </tr>
                    </tbody>
                </table>
            </fieldset>
            <footer>
                <button width="80" @click="close" type="submit">Закрыть</button>
            </footer>
        </form>
    </v-dialog-old>
</template>

<script>
export default {
    data: function () {
        return {
            result: {
                type: Object,
                required: true,
            },
            errorsBag: {
                type: Array,
                default: [],
            },
        };
    },
    methods: {
        show (result, errorsBag) {
            this.result = result;
            this.errorsBag = errorsBag;

            this.$refs.dialog.show();
        },
        close() {
            this.$refs.dialog.hide();
        }
    }
}
</script>
